import { render } from "./dayone-grid.vue?vue&type=template&id=0661a1fe"
import script from "./dayone-grid.vue?vue&type=script&lang=js"
export * from "./dayone-grid.vue?vue&type=script&lang=js"
script.render = render

export default script